import React,{useState,useEffect} from 'react'
import '../Css/Registry.css';

import '../App.css';
import axios from 'axios';
import {toast} from "react-toastify";
import { useNavigate } from 'react-router-dom';
import calendar from '../icon/icons8-calendar-96.png';
import poker from '../icon/icons8-poker-96.png';

function SkillCourse() {
    //navigation
  const navigate = useNavigate();
  const [phoneNum,setPhoneNum] = useState('');
  const [name,setName] = useState('');
  const [email,setEmail] = useState('');
  const [gender,setGender] = useState('');
  
  
  //store the event
  const [data,setData] = useState([]);

  //store the booking event
  const [selectedEvents, setSelectedEvents] = useState([])
    
  //connect to api to get result
    function connectPhp(){
        let data =[];
        axios.get("https://www.pta-hk.com/getSkillCourseRegistryList.php").then
        (response=>{
            data = response.data;
            setData(data);
            console.log(data);
        }).catch((e)=>console.log(e));
    }

    function bookingEvent(){

        const url="https://pta-hk.com/dealerRegistryBooking.php";
        let fData =new FormData();
        fData.append('name',name);
        fData.append('phoneNum',phoneNum);
        fData.append('gender',gender);
        fData.append('email',email);
        
        //pass all seleced event to array
        selectedEvents.forEach(event => {
            fData.append('selectedEvents[]', event);
        });
                
        axios.post(url,fData).then
        (response=>{
                let dataResponse = response.data;
                console.log(dataResponse);
                if(dataResponse ==="bookingSuccess"){
                    toast.success("預約成功,我們將以 WhatsApp 聯絡閤下..",{
                        position:"top-center",
                    });      
                    //navigate to Home component
                     navigate('/Home');

                }
        }).catch((e)=>console.log(e));
        
    }

    useEffect(()=>{
        connectPhp();
    },[]);


  function handlePhoneChange(e){
    const value =e.target.value;
    setPhoneNum(value);
  }
  
  function handleNameChange(e){
    const value = e.target.value;
    setName(value);
  }

  function handleEmailChange(e){
    const value = e.target.value;
    setEmail(value);
  }

  function handleGenderChange(e){
    const value = e.target.value;
    setGender(value);
  }

  // Handle checkbox selection
  const handleEventSelection = (eventId) => {
    setSelectedEvents(prevSelected => {
      if (prevSelected.includes(eventId)) {
        // If already selected, remove it
        return prevSelected.filter(id => id !== eventId);
      } else {
        // If not selected, add it
        return [...prevSelected, eventId];
      }
    });
  };
    
      
  const handleSubmit = (e)=>{
    e.preventDefault();
    const cleanedPhoneNum = phoneNum.replace(/[^\d]/g, '').slice(0, 8);
      //check the start of number
      //^ start of number
      //[23569] -First digit must be 
      //d{7} -followed by 7 digit
      const valid = /^[23569]\d{7}$/.test(cleanedPhoneNum);
      console.log("Valid PhoneNum", valid);
    
    //valid phone number checked
    if (valid) {
        console.log('valid phone submitted !');
        bookingEvent();
        console.log("PhoneNumber : ",phoneNum);
        console.log("Name: ",name);
        

    }else{
        toast.error("請輸入有效電話號碼..",{
            position:"top-center",
        });      
        console.log('Please enter a valid telephone number ');
    }    
   
  }  

  return (
    <div className="container">
        <div className="container-content">
            <div className="registry-content">
                <div className="title">樸克技巧訓練班&nbsp;&nbsp;
                    <img src={poker}
                        alt="Poker Tournament Association"
                        className="icon"
                    />
                </div>
                <form onSubmit = {handleSubmit} className="booking-form">
                    <div className="booking-form-group">
                         <div className="form-notice">
                            *必須墳寫
                        </div>
                    </div>
                    {/********  Name ******/}  
                     <div className="booking-form-group">
                        <label span id="formInputLabel">姓名*:&nbsp;&nbsp;</label>&nbsp;&nbsp;
                        <input className="form-input"
                            required
                            type="text"
                            id="name"
                            value={name}
                            
                            onChange={handleNameChange}
                                style={{
                                  padding:'8px',
                                  border:`1px solid #ccc`,
                                  borderRadius:'4px',
                                  width:'200px' ,
                                  backgroundColor:"#e0e0e0"
                                }}
                        />
                    </div>

                    {/********** Phone Input *****/}
                    <div className="booking-form-group">
                        <label span id="formInputLabel">聯絡電話*:</label>&nbsp;&nbsp;
                        <input className="form-input"
                            required
                            type="text"
                            maxLength={8}
                            id="phone"
                            value={phoneNum}
                            onChange={handlePhoneChange}
                            style={{
                                padding:'8px',
                                border:`1px solid #ccc`,
                                borderRadius:'4px',
                                width:'200px',
                                backgroundColor:"#e0e0e0" 
                            }}
                        />
                    </div>

                    {/************** Email ********************/}
                       <div className="booking-form-group">
                        <label span id="formInputLabel">電郵*:</label>&nbsp;&nbsp;
                        <input className="form-input"
                            required
                            type="email"
                            id="email"
                            value={email}
                            
                            onChange={handleEmailChange}
                            style={{
                                padding:'8px',
                                border:`1px solid #ccc`,
                                borderRadius:'4px',
                                width:'200px',
                                backgroundColor:"#e0e0e0" 
                            }}
                        />
                    </div>
                    
                    {/********** Gender *****/}
                    <div className="booking-form-group">
                          <label span id="formInputLabel">性別*:</label>&nbsp;&nbsp;      
                          <label>
                            <input
                              type="radio"
                              value="M"
                              checked={gender=== 'M'}
                              onChange={handleGenderChange}
                            />
                            男性
                          </label>
                          <label>
                            <input
                              type="radio"
                              value="F"
                              checked={gender==='F'}
                              onChange={handleGenderChange}
                            />
                            女性
                          </label>
                    </div>


                    {/**** Show all event list */}
                    <div className="booking-form-group">
                        <div className="eventTable">
                            <div className="title">上課日程 &nbsp;&nbsp;
                                <img src={ calendar }
                                    alt="Poker Tournament Association"
                                    className="icon"
                                />
                            </div>
                         

                         
                            <table className="data-table">
                                <thead>
                                    <tr>
                                        <th>選擇</th>
                                        <th>編號</th>
                                        <th>開課日期</th>
                                        <th>上課時間</th>
                                        <th>費用</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {data.length >0 ?  
                                    data.map((item)=>(
                                        <tr key={item.id}>
                                            <td>
                                                <input className="form-input"
                                                    type="checkbox"
                                                    id={`event-${item.lessonCode}`}
                                                    checked={selectedEvents.includes(item.lessonCode)}
                                                    onChange={() => handleEventSelection(item.lessonCode)}
                                                    style={{
                                                        padding:'8px',
                                                        border:`1px solid #ccc`,
                                                        borderRadius:'4px',
                                                        backgroundColor:"#e0e0e0" 
                                                    }}

                                                />
                                            </td>
                                        <td>{item.lessonCode}</td>
                                        <td>{item.startDate1}</td>
                                        <td>{item.startTime}</td>
                                        <td>{item.fee}</td>
                                    </tr>
                                ))
                                :<td>未有課堂資料</td>
                                }
                                </tbody>
                            </table>
                         
                            <div id="submitButton">
                                <button type="submit"
                                    onClick={() => console.log("Button clicked!")}
                                    style={{
                                    backgroundColor:'#F01010',
                                    color:'#ffffff',
                                    marginTop:'20px',
                                    padding:'8px 15px',
                                    border:'none',
                                    borderRadius:'4px',
                                    cursor:'pointer',
                                    width:'200px'
                                    }}
                                >
                                    確認
                                </button>  
                            </div>     
                        </div>        
                    </div>
                </form>    
            </div>
            
        </div>
    </div>                    
  )


  
}

export default SkillCourse
